// Детсад: больше не применяем отдельный mobile-фильтр карточек цен.
// Используем единое поведение из components/priceSlider.js, чтобы набор карточек
// на мобильной версии совпадал с ПК.
(function () {
  function init() {
    // Файл оставлен как no-op для безопасной совместимости импорта.
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

